import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, finalize, map, take } from 'rxjs';
import { UserSessionService } from '../services';
import { TokenService } from '../services/utils/token.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        private readonly tokenService: TokenService,
        private readonly ngxSpinnerService: NgxSpinnerService,
        private readonly userSessionService: UserSessionService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isPaymentTokenLink =
            state.url.includes('admin/facilityPayments/newPayment?') &&
            Object.keys(route.queryParams).length > 0 &&
            !('searchTerms' in route.queryParams);

        if (isPaymentTokenLink) {
            this.ngxSpinnerService.show();
            return this.userSessionService.signInAsGuest().pipe(
                take(1),
                map((tokens) => !!tokens),
                finalize(() => {
                    this.ngxSpinnerService.hide();
                })
            );
        }

        if (this.tokenService.isAuthenticated()) {
            return true;
        }

        this.userSessionService.logout();
        return false;
    }
}
